import styled from "styled-components";
import React from "react";

interface IProps {
  setActiveTab: (id: number) => void;
  tabs: { id: number; title: string }[];
  activeTab: number;
  className?: string;
}

export function Tabs(props: IProps) {
  return (
    <StyledTabs className={props.className}>
      {props.tabs.map((item) => (
        <StyledTab
          key={item.id}
          onClick={() => props.setActiveTab(item.id)}
          isActive={item.id === props.activeTab}
        >
          {item.title}
        </StyledTab>
      ))}
    </StyledTabs>
  );
}

const StyledTabs = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  grid-gap: 1.2rem;
`;

const StyledTab = styled.button<{ isActive: boolean }>`
  padding: 0.8rem 1.2rem;
  border-radius: 0.4rem;
  font-size: 1.6rem;
  color: ${({ isActive, theme }) =>
    isActive ? theme.colors.basic_white : theme.colors.primary_light_gray};
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.colors.primary_red : theme.colors.primary_light_gray};
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.primary_red : "none"};
  transition: all 0.3s ease;

  &:hover {
    color: ${({ isActive, theme }) =>
      isActive ? theme.colors.basic_white : theme.colors.primary_red};
    border-color: ${(props) => props.theme.colors.primary_red};
  }

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    padding: 1.2rem;
  }
`;
